export default __webpack_public_path__ + "static/fb-6c797b2c321a804e74b60c3d95da63d3.png";